import { useRef, useCallback } from 'react';

export type EventListenerManager<T extends (...args: any[]) => void> = {
  emit: (...args: Parameters<T>) => void;
  listen: (listener: T) => T;
  remove: (listener: T) => void;
};

export function useEventListenerManager<T extends (...args: any[]) => void>(): EventListenerManager<
  T
> {
  const listenersRef = useRef<Set<T>>(new Set());

  const emit = useCallback((...args: Parameters<T>) => {
    listenersRef.current.forEach((listener) => {
      try {
        listener(...args);
      } catch (err) {
        console.error('Listener threw an error:', err);
      }
    });
  }, []);

  const listen = useCallback((listener: T): T => {
    listenersRef.current.add(listener);
    return listener;
  }, []);

  const remove = useCallback((listener: T) => {
    listenersRef.current.delete(listener);
  }, []);

  return {
    emit,
    listen,
    remove,
  };
}
